import React, { useContext } from 'react';
import Link from 'next/link';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import TNHContext from '@contexts/TNHContext';

export default function SlideSpecialty({ specialty }) {
    const { hotline } = useContext(TNHContext);
    const {locale} = useRouter();

    const handleCall = () => {
        if (hotline) {
            window.location.href = `tel:${hotline}`;
        }
    };

    return (
        <section className="hospital-system">
            <div>
                <img className="hospital-system__bg" src="/bw_image/medial-facility.png" alt={getLocaleContent(locale, 'page.specialty-page.breadcrumb-title')} />
                <div className="hospital-system__actions">
                    <div className="hospital-system__card" onClick={handleCall} style={{ cursor: 'pointer' }}>
                        <div className="hospital-system icon card--red">
                            <img src="/bw_image/call.svg" alt={getLocaleContent(locale, 'page.specialty-page.call-hotline')} className="icon" />
                        </div>
                        <span className="hospital-system text--red">{getLocaleContent(locale, 'page.specialty-page.call-hotline')}</span>
                    </div>
                    <div className="hospital-system-actions__sparate"></div>
                    <Link href="/chuyen-gia-bac-si">
                        <div className="hospital-system__card" style={{ cursor: 'pointer' }}>
                            <div className="hospital-system icon card--yellow">
                                <img src="/bw_image/doctor.svg" alt={getLocaleContent(locale, 'page.specialty-page.find-doctor')} className="icon" />
                            </div>
                            <span className="hospital-system text--yellow">{getLocaleContent(locale, 'page.specialty-page.find-doctor')}</span>
                        </div>
                    </Link>
                    <div className="hospital-system-actions__sparate"></div>
                    <Link href="/dat-lich-kham">
                        <div className="hospital-system__card" style={{ cursor: 'pointer' }}>
                            <div className="hospital-system icon card--green">
                                <img src="/bw_image/calendar.svg" alt={getLocaleContent(locale, 'page.specialty-page.book-appointment')} className="icon" />
                            </div>
                            <span className="hospital-system text--green">{getLocaleContent(locale, 'page.specialty-page.book-appointment')}</span>
                        </div>
                    </Link>
                </div>
            </div>
            <div className="hospital-system__title">
                <h1>{specialty?.department_name || getLocaleContent(locale, 'page.specialty-page.default-title')}</h1>
            </div>
        </section>
    );
}
